__turbopack_context__.v({
  "body": "vTqT0a_body",
  "header": "vTqT0a_header",
  "link": "vTqT0a_link",
  "meta": "vTqT0a_meta",
  "noBreak": "vTqT0a_noBreak",
  "root": "vTqT0a_root",
  "title": "vTqT0a_title",
});
